import { useQuery } from '@tanstack/react-query';

import { usePasswordProtectedQueries } from '@app-velocity/modules/password-sharing';

export const useGetScenarioReviewsByShareTokenQuery = (shareToken?: string) => {
  const { getScenarioReviewsByShareToken } = usePasswordProtectedQueries();

  return useQuery({
    enabled: !!shareToken,
    queryKey: ['scenario-shared-reviews', shareToken],
    queryFn: async () => {
      if (!shareToken) return null;

      return await getScenarioReviewsByShareToken(shareToken, {statuses: ['COMPLETED', 'CANCELED']});
    }
  });
};
